var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"notfound d-flex align-center jusitfy-center"},[_c('div',{staticClass:"text-cennter"},[_c('img',{staticClass:"notfound__img",attrs:{"src":require("../assets/image.png"),"alt":""}}),_c('h1',{staticClass:"text-center"},[_vm._v("لا يمكن الحصول علي عنوان الرابط ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }